@let logoLink = exhibitionSettings?.isHeaderLogoLinkVisible ? exhibitionSettings?.headerLogoLink : '';

<header class="header bg-white">
  <div class="header-wrapper sticky z-1 p-x-7" [class.shadow-2]="!isMobileMenuOpen">
    <nav class="navigation flex flex-wrap align-items-center justify-content-between h-full">
      <a [routerLink]="[]" fragment="accessibility-sidebar-toggle-button" class="skip-link button-primary">
        {{ 'a11y.skip-to.accessibility-sidebar' | translate }}
      </a>

      @if (isEventSelected) {
        <a [routerLink]="[]" fragment="step-navigation" class="skip-link button-primary">
          {{ 'a11y.skip-to.step-navigation' | translate }}
        </a>
        <a [routerLink]="[]" fragment="main-content" class="skip-link button-primary">
          {{ 'a11y.skip-to.main-content' | translate }}
        </a>
      }

      <ul class="flex align-items-center gap-1 list-none">
        @if (logoImage) {
          <li class="logo-wrapper flex relative">
            <ng-container *ngTemplateOutlet="logoImageTemplate" />

            @if (logoLink) {
              <a
                class="flex"
                target="_blank"
                [attr.aria-label]="'a11y.top-bar.logo.url' | translate: { eventName: exhibitionSettings.eventSerie }"
                [href]="logoLink"
                [ngClass]="{
                  'pointer-events-none': !!isEventSelected
                    ? !exhibitionSettings?.isHeaderLogoLinkVisible
                    : !operatorsSettings?.isHeaderLogoLinkVisible
                }"
              >
              </a>
            }

            @if (ageRating()) {
              <app-age-rating [rating]="ageRating()" [adjustPositions]="{ top: '10px', right: '5px' }" />
            }
          </li>
        }

        @if (!isMobileResolution) {
          <li>
            <ng-container *ngTemplateOutlet="selectEventTemplate; context: { buttonSize: 'sm' }" />
          </li>
        }
      </ul>

      <ng-container *ngTemplateOutlet="mobileMenuWrapperTemplate" />

      @if (!isMobileResolution) {
        <ng-container *ngTemplateOutlet="navigationTemplate" />
      }
    </nav>
  </div>

  @if (isMobileResolution) {
    <ng-container *ngTemplateOutlet="mobileNavigationTemplate" />
  }
</header>

<ls-modal
  data-nested-translation="navigation.logo.modalWindow.title"
  [title]="'navigation.logo.modalWindow.title' | translate | hideTranslation"
  [visible]="modalWindowOpen"
  [closable]="false"
  [footerContent]="false"
>
  <div class="flex flex-wrap justify-content-center gap-1">
    <ls-button
      data-nested-translation="navigation.modalWindow.leave-page"
      [styleClass]="'button-primary'"
      [color]="'primary'"
      [size]="'md'"
      [label]="'navigation.modalWindow.leave-page' | translate | hideTranslation"
      (onClick)="submitModalWindow($event)"
    />

    <ls-button
      data-nested-translation="navigation.modalWindow.stay-on-page"
      [styleClass]="'button-secondary'"
      [color]="'secondary'"
      [size]="'md'"
      [label]="'navigation.modalWindow.stay-on-page' | translate | hideTranslation"
      (onClick)="closeModalWindow($event)"
    />
  </div>
</ls-modal>

<ng-template #mobileMenuWrapperTemplate>
  @if (isMobileResolution) {
    <ul class="mobile-menu-wrapper flex align-items-center list-none font-medium">
      <li class="uppercase p-y-2">
        <ng-container *ngTemplateOutlet="changeLanguageTemplate" />
      </li>

      @if (isEventSelected && selectedStep !== 'invoice' && !isSelfRegistrationEnabled()) {
        @if (bookedProductsCount()) {
          <li class="p-y-2 m-r-6">
            <ng-container
              *ngTemplateOutlet="basketCountTemplate; context: { bookedProductsCount: bookedProductsCount() }"
            />
          </li>
        }
      }

      @if (!isSelfRegistrationEnabled() || (isSelfRegistrationEnabled() && isLoggedInAsAdmin())) {
        @let mobileMenuAriaLabel =
          (isMobileMenuOpen ? 'a11y.top-bar.mobile-menu.close' : 'a11y.top-bar.mobile-menu.open') | translate;

        <li class="p-y-2">
          <div
            class="mobile-menu-wrapper__icon"
            role="switch"
            tabindex="0"
            [attr.aria-label]="mobileMenuAriaLabel"
            [attr.aria-checked]="isMobileMenuOpen"
            [class.mobile-menu-wrapper__icon--open]="isMobileMenuOpen"
            (click)="onToggleMobileMenuButton($event)"
            (keydown.enter)="onToggleMobileMenuButton($event)"
            (keydown.space)="onToggleMobileMenuButton($event)"
          >
            <span></span><span></span><span></span><span></span>
          </div>
        </li>
      }
    </ul>
  }
</ng-template>

<ng-template #selectEventTemplate let-buttonSize="buttonSize">
  <div class="select-event-wrapper font-medium cursor-pointer">
    @if (!isSelfRegistrationEnabled() && !isEventSeriesPage) {
      @if (displayOnMaintenancePage || (!isEventSelected && !isRootUrl)) {
        @if (displayOnMaintenancePage) {
          <ls-button
            data-nested-translation="navigation.select-event.maintenance"
            [styleClass]="'button-primary'"
            [color]="'primary'"
            [size]="buttonSize"
            [icon]="'la-arrow-left'"
            [label]="'navigation.select-event.maintenance' | translate | hideTranslation"
            (onClick)="goToSelectEvent()"
          />
        } @else {
          <ls-button
            data-nested-translation="navigation.select-event"
            [styleClass]="'button-primary'"
            [color]="'primary'"
            [size]="buttonSize"
            [icon]="'la-arrow-left'"
            [label]="'navigation.select-event' | translate | hideTranslation"
            (onClick)="goToSelectEvent()"
          />
        }
      }

      @if (isEventSelected && displayBackToEvent && selectedStep !== 'invoice') {
        @if ('navigation.back-to-event' | translate | hideTranslation; as backToEventTranslation) {
          <ls-button
            data-nested-translation="navigation.back-to-event"
            [styleClass]="'button-primary'"
            [color]="'primary'"
            [size]="buttonSize"
            [icon]="'la-arrow-left'"
            [label]="backToEventTranslation"
            (onClick)="openModalWindow()"
          />
        }
      }

      @if (isEventSelected && !displayBackToEvent && !displayOnMaintenancePage) {
        <ls-button
          data-nested-translation="navigation.back-to-shop"
          [styleClass]="'button-primary'"
          [color]="'primary'"
          [size]="buttonSize"
          [icon]="'la-arrow-left'"
          [label]="'navigation.back-to-shop' | translate | hideTranslation"
          (onClick)="onBackToShop()"
        />
      }
    }

    @if (isEventSelected && isSelfRegistrationEnabled() && displayBackToSelfRegistration) {
      <ls-button
        data-nested-translation="navigation.back-to-self-reg"
        [styleClass]="'button-primary'"
        [color]="'primary'"
        [size]="buttonSize"
        [icon]="'la-arrow-left'"
        [label]="'navigation.back-to-self-reg' | translate | hideTranslation"
        (onClick)="onBackToSelfRegistration()"
      />
    }
  </div>
</ng-template>

<ng-template #navigationTemplate>
  <ul class="flex align-items-center list-none font-medium">
    @if (bookedProductsCount()) {
      <li class="p-y-2 m-r-6">
        <app-countdown class="flex flex-column align-items-end" />
      </li>
    }

    @if (isSelfRegistrationEnabled()) {
      <li class="p-y-2 m-r-6">
        <app-reset-button />
      </li>
    }

    @if (isLoggedInAsAdmin()) {
      <li class="uppercase p-y-2 m-r-6">
        <ng-container *ngTemplateOutlet="translationTemplate" />
      </li>
    }

    @if (isEventSelected && isLoggedInAsAdmin()) {
      <li class="uppercase p-y-2 m-r-6">
        <ng-container *ngTemplateOutlet="widgetTemplate" />
      </li>
    }

    @if (legitimationStatus() && legitimationStatus() !== LegitimationStatus.New && !isSelfRegistrationEnabled()) {
      <li class="uppercase p-y-2 m-r-6">
        <ng-container
          *ngTemplateOutlet="legitimationStatusTemplate; context: { legitimationStatus: legitimationStatus() }"
        />
      </li>
    }

    <li class="uppercase p-y-2">
      <ng-container *ngTemplateOutlet="changeLanguageTemplate" />
    </li>

    @if (isEventSelected && selectedStep !== 'invoice' && !isSelfRegistrationEnabled()) {
      @if (bookedProductsCount()) {
        <li class="p-y-2 m-r-6">
          <ng-container
            *ngTemplateOutlet="basketCountTemplate; context: { bookedProductsCount: bookedProductsCount() }"
          />
        </li>
      }
    }

    @if (!isLoggedIn() && !hideTopBarLogin() && !isSelfRegistrationEnabled() && !displayOnMaintenancePage) {
      <li class="p-y-2">
        <ng-container *ngTemplateOutlet="loginButtonTemplate; context: { buttonSize: 'sm', icon: 'la-user-circle' }" />
      </li>
    }

    @if (
      selectedStep !== 'invoice' && selectedStep !== 'recipe' && !displayOnMaintenancePage && isLoggedIn() && profile()
    ) {
      <li class="p-y-2">
        <ls-split-button
          [label]="'Hi, ' + profile().firstName"
          [color]="'info'"
          [icon]="'la-user-circle'"
          [iconPos]="'right'"
          [menuIcon]="''"
          [size]="'md'"
          [items]="profileMenuDropdownItems()"
        />
      </li>
    }
  </ul>
</ng-template>

<ng-template #mobileNavigationTemplate>
  <nav
    class="mobile-navigation bg-white shadow-2 font-medium flex flex-column"
    [class.mobile-navigation--open]="isMobileMenuOpen"
  >
    <ul class="list-none text-center text-lg border-top-1 p-x-6 m-0">
      @if (bookedProductsCount()) {
        <li class="m-t-6 m-b-4">
          <app-countdown class="flex flex-column align-items-center" />
        </li>
      }

      @if (
        selectedStep !== 'invoice' &&
        selectedStep !== 'recipe' &&
        !displayOnMaintenancePage &&
        isLoggedIn() &&
        profile()
      ) {
        <li class="user-full-name text-base border-1 border-round-sm p-x-6 p-y-4 m-t-6">
          <p>{{ profile().firstName }} {{ profile().lastName }}</p>
        </li>

        <li class="flex align-items-center justify-content-center gap-2 m-4 m-b-6">
          <i class="las la-user-circle text-3xl"></i>

          <a
            data-translation="navigation.profile"
            routerLink="/profile"
            [attr.aria-label]="'a11y.top-bar.profile' | translate"
            [routerLinkActive]="['active-navigation-link']"
            (click)="onCloseMobileMenu($event)"
            (keydown.enter)="onCloseMobileMenu($event)"
            (keydown.space)="onCloseMobileMenu($event)"
          >
            {{ 'navigation.profile' | translate | hideTranslation }}
          </a>

          @if (
            legitimationStatus() && legitimationStatus() !== LegitimationStatus.New && !isSelfRegistrationEnabled()
          ) {
            <ng-container
              *ngTemplateOutlet="legitimationStatusTemplate; context: { legitimationStatus: legitimationStatus() }"
            />
          }
        </li>
      }

      @if (isEventSelected && selectedStep !== 'invoice' && !isSelfRegistrationEnabled()) {
        @if (bookedProductsCount()) {
          <li class="flex justify-content-center align-items-center gap-2 m-4 m-b-6">
            <ng-container
              *ngTemplateOutlet="
                basketCountTemplate;
                context: { bookedProductsCount: bookedProductsCount(), showText: true }
              "
            />
          </li>
        }
      }
    </ul>

    <ul class="list-none text-center text-lg border-top-1 p-x-6 m-0">
      @if (isLoggedInAsAdmin()) {
        <li class="m-t-6 m-b-2">
          <ng-container *ngTemplateOutlet="mobileTranslationTemplate" />
        </li>
      }

      @if (isEventSelected && isLoggedInAsAdmin()) {
        <li>
          <ng-container *ngTemplateOutlet="mobileWidgetTemplate" />
        </li>
      }

      @if (!isLoggedIn() && !hideTopBarLogin() && !isSelfRegistrationEnabled() && !displayOnMaintenancePage) {
        <li class="m-t-6 m-b-2">
          <ng-container
            *ngTemplateOutlet="loginButtonTemplate; context: { buttonSize: 'md', icon: 'la-sign-in-alt' }"
          />
        </li>
      }

      @if (profile() && !displayOnMaintenancePage) {
        <li class="m-t-6 m-b-2">
          <ls-button
            data-translation="navigation.logout"
            [styleClass]="'button-primary'"
            [color]="'primary'"
            [size]="'md'"
            [icon]="'la-sign-out-alt'"
            [label]="'navigation.logout' | translate | hideTranslation"
            (onClick)="userService.logout(); onCloseMobileMenu()"
          />
        </li>
      }

      <li class="m-t-2 m-b-6">
        <ng-container *ngTemplateOutlet="selectEventTemplate; context: { buttonSize: 'md' }" />
      </li>
    </ul>
  </nav>
</ng-template>

<ng-template #translationTemplate>
  <a
    routerLink="/translations"
    [attr.aria-label]="'a11y.top-bar.translations' | translate"
    [routerLinkActive]="['active-navigation-link']"
    (click)="onCloseMobileMenu($event)"
    (keydown.enter)="onCloseMobileMenu($event)"
    (keydown.space)="onCloseMobileMenu($event)"
  >
    <i class="las la-language text-3xl vertical-align-middle"></i>

    <span data-translation="navigation.translations">
      {{ 'navigation.translations' | translate | hideTranslation }}
    </span>
  </a>
</ng-template>

<ng-template #mobileTranslationTemplate>
  <a
    class="button-primary p-button p-button-primary p-button-md flex"
    routerLink="/translations"
    [attr.aria-label]="'a11y.top-bar.translations' | translate"
    [routerLinkActive]="['p-disabled']"
    (click)="onCloseMobileMenu($event)"
    (keydown.enter)="onCloseMobileMenu($event)"
    (keydown.space)="onCloseMobileMenu($event)"
  >
    <span class="las la-language"></span>

    <span class="p-button-label p-l-0" data-translation="navigation.translations">
      {{ 'navigation.translations' | translate | hideTranslation }}
    </span>
  </a>
</ng-template>

<ng-template #widgetTemplate>
  <a
    routerLink="/widget-admin"
    ariaCurrentWhenActive="page"
    [attr.aria-labelledby]="'top-bar-widget-admin'"
    [routerLinkActive]="['active-navigation-link']"
    (click)="onCloseMobileMenu($event)"
    (keydown.enter)="onCloseMobileMenu($event)"
    (keydown.space)="onCloseMobileMenu($event)"
  >
    <i class="las la-window-maximize text-3xl vertical-align-middle"></i>

    <span id="top-bar-widget-admin" data-translation="navigation.widget">Widget</span>
  </a>
</ng-template>

<ng-template #mobileWidgetTemplate>
  <a
    class="button-primary p-button p-button-primary p-button-md flex"
    routerLink="/widget-admin"
    [attr.aria-label]="'a11y.top-bar.widget-admin' | translate"
    [routerLinkActive]="['p-disabled']"
    (click)="onCloseMobileMenu($event)"
    (keydown.enter)="onCloseMobileMenu($event)"
    (keydown.space)="onCloseMobileMenu($event)"
  >
    <span class="las la-window-maximize"></span>

    <span class="p-button-label p-l-0" data-translation="navigation.widget">Widget</span>
  </a>
</ng-template>

<ng-template #legitimationStatusTemplate let-legitimationStatus="legitimationStatus">
  <div class="legitimation-status-wrapper flex flex-column border-1 border-round-sm p-x-4 p-y-2">
    <span class="font-bold" data-translation="navigation.legitimation-status.text">
      {{ 'navigation.legitimation-status.text' | translate | hideTranslation }}:
    </span>

    @switch (legitimationStatus) {
      @case (LegitimationStatus.InProgress) {
        <span
          class="legitimation-status-pending font-semibold"
          data-translation="navigation.legitimation-status.text-inProgress"
        >
          {{ 'navigation.legitimation-status.text-inProgress' | translate | hideTranslation }}
        </span>
      }
      @case (LegitimationStatus.Approved) {
        <span
          class="legitimation-status-approved font-semibold"
          data-translation="navigation.legitimation-status.text-approved"
        >
          {{ 'navigation.legitimation-status.text-approved' | translate | hideTranslation }}
        </span>
      }
      @case (LegitimationStatus.Rejected) {
        <span
          class="legitimation-status-rejected font-semibold"
          data-translation="navigation.legitimation-status.text-rejected"
        >
          {{ 'navigation.legitimation-status.text-rejected' | translate | hideTranslation }}
        </span>
      }
    }
  </div>
</ng-template>

<ng-template #changeLanguageTemplate>
  <ls-dropdown
    tabindex="0"
    data-testid="navigation-dropdown-change-language"
    [options]="supportedLanguages()"
    [showClear]="false"
    [required]="true"
    [selectedOption]="currentLanguage()"
    (selectedOptionChange)="onChangeLanguage($event)"
  />
</ng-template>

<ng-template #basketCountTemplate let-bookedProductsCount="bookedProductsCount" let-showText="showText">
  @if (!!bookedProductsCount) {
    <div class="relative" [class.inline-block]="showText">
      <div
        role="switch"
        tabindex="0"
        [attr.aria-label]="'a11y.top-bar.basket' | translate"
        [attr.aria-checked]="isBasketOpen"
        (click)="onToggleBasket($event)"
        (keydown.enter)="onToggleBasket($event)"
        (keydown.space)="onToggleBasket($event)"
      >
        <i class="las la-shopping-bag text-3xl cursor-pointer"></i>

        <div
          class="basket-count absolute text-xs flex justify-content-center align-items-center border-circle pointer-events-none"
        >
          {{ bookedProductsCount }}
        </div>
      </div>
    </div>
  }

  @if (showText) {
    <span data-translation="navigation.basket" (click)="onToggleBasket($event)">
      {{ 'navigation.basket' | translate | hideTranslation }}
    </span>
  }
</ng-template>

<ng-template #loginButtonTemplate let-buttonSize="buttonSize" let-icon="icon">
  <ls-button
    data-nested-translation="navigation.login"
    data-testid="navigation-login-button"
    [styleClass]="'button-primary'"
    [color]="'primary'"
    [size]="buttonSize"
    [icon]="icon"
    [label]="'navigation.login' | translate | hideTranslation"
    [disabled]="router.url === '/login'"
    (onClick)="onLoginClick()"
  />
</ng-template>

<ng-template #logoImageTemplate>
  @if (exhibitionSettings?.eventSerie && logoImage) {
    <img
      class="operator-logo p-y-2"
      [class.cursor-pointer]="!!logoLink"
      [alt]="exhibitionSettings.eventSerie"
      [src]="logoImage"
      (click)="goToUrl($event, logoLink)"
    />
  }
</ng-template>
